export default "__VITE_ASSET__CRoa8GLS__"